const descendingComparator = (a, b, orderBy, dashOrder = 1) => {
    let aValue = a[orderBy];
    let bValue = b[orderBy];

    if (aValue === "-" && bValue === "-") return 0;
    if (aValue === "-") return dashOrder * 1;
    if (bValue === "-") return dashOrder * -1;

    const numericPattern = /^(\$[\d,.]+|[\d,.]+%)$/;
    if (numericPattern.test(aValue) && numericPattern.test(bValue)) {
        return (
            parseFloat(bValue.replace(/[$,%]/g, "")) -
            parseFloat(aValue.replace(/[$,%]/g, ""))
        );
    }

    if (bValue < aValue) return -1;
    if (bValue > aValue) return 1;
    return 0;
};

export const getComparator = (order, orderBy) => {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy, -1);
};

export const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};